module.exports = __webpack_public_path__ + "static/media/icon-social-reach.c40a06b8.svg";